import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { getLastResults, getDetailResults } from "../../../apiservices/CasionApi";
import RefResultModal from "../../casinoComponents/refResultModal";
import { formatRefMatchTime } from "../../../utils/refMatchTime";

const WIN_CLASS = { 1: "resulta", 2: "resultb", 0: "resulttie" };

/**
 * Last Result items for Andar Bahar 2 (abj), reference LastResultsSection "abj" branch, rendered inside
 * .casino-video-last-results: span.resulta "A" (win 1) / span.resultb "B" (win 2) / span.resulttie "T" (win 0).
 * Refetched when the round (mid) changes. Click → .loader-overlay while the round detail loads, then the
 * reference result modal ("{ename} Result") with `renderBody(t1)`.
 */
export default function AbjRefResults({ gameType, mid, fallbackTitle = "", renderBody }) {
  const apiType = String(gameType || "").toLowerCase().trim();
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!apiType) return;
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        const res = response?.data?.data?.res;
        if (Array.isArray(res)) setLastResults(res);
      } catch (e) {
        console.error("Error fetching last results:", e);
      }
    };
    fetchLastResults();
  }, [apiType, mid]);

  const handleResultClick = async (rmid) => {
    if (loading || !rmid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, String(rmid));
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (e) {
      console.error("Error fetching detail results:", e);
    }
    setLoading(false);
  };

  return (
    <>
      {lastResults.map((r, i) => {
        const win = String(r?.win ?? "");
        return (
          <span key={`${r?.mid}-${i}`} className={WIN_CLASS[win] || undefined} onClick={() => handleResultClick(r?.mid)}>
            {win === "1" ? "A" : null}
            {" "}
            {win === "2" ? "B" : null}
            {" "}
            {win === "0" ? "T" : null}
          </span>
        );
      })}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector(".page-content") || document.body)}
      <RefResultModal
        show={showModal && !!detailResult}
        onHide={() => setShowModal(false)}
        title={`${detailResult?.ename || fallbackTitle} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        {detailResult && renderBody ? renderBody(detailResult) : null}
      </RefResultModal>
    </>
  );
}
